<!-- <p>calendar-picker works!</p> -->
<div class="visitor-calendar" #getHeight (click)="calendarToggle()">
  <mat-card class="visitor-calendar-card">
    <mat-calendar
      class="check"
      [headerComponent]="exampleHeader"
      [(selected)]="date"
    ></mat-calendar>
  </mat-card>
</div>
